var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponBackgroundLtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 118,
    viewBox: "0 0 343 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_794)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.491 5.8125C118.568 2.21571 122.405 0 126.558 0H331C337.627 0 343 5.37259 343 12V106C343 112.627 337.627 118 331 118H126.342C122.233 118 118.437 115.808 116.383 112.25C111.956 104.583 100.89 104.583 96.4641 112.25C94.4098 115.808 90.6134 118 86.5048 118H12C5.37258 118 0 112.627 0 106V12C0 5.37258 5.37258 0 12 0H86.2883C90.4415 0 94.2792 2.21571 96.3559 5.8125C100.83 13.5625 112.016 13.5625 116.491 5.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 12V106",
    stroke: "#D9DCE1",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponBackgroundLtr);
export default __webpack_public_path__ + "static/media/coupon-background-ltr.3826300e96e682783dcc56e90c23994f.svg";
export { ForwardRef as ReactComponent };